import React from "react";

/* Slow ambient drift */
const ambient = [
  { left: "8%", top: "18%", size: 3, dur: 24, delay: 0 },
  { left: "72%", top: "22%", size: 2.5, dur: 26, delay: 3 },
  { left: "48%", top: "62%", size: 3, dur: 22, delay: 1.5 },
  { left: "22%", top: "48%", size: 2, dur: 28, delay: 5 },
  { left: "85%", top: "55%", size: 2.5, dur: 25, delay: 2 },
];

/* Subtle faster twinkle — not too many */
const active = [
  { left: "58%", top: "28%", size: 3, dur: 9, delay: 0 },
  { left: "18%", top: "38%", size: 2.5, dur: 8, delay: 2 },
  { left: "42%", top: "52%", size: 3, dur: 10, delay: 4 },
];

/*
 * 3 falling stars per ~30s cycle — staggered, varied depth (near / mid / far).
 * cycleDelay offsets when each star falls within the 30s loop.
 */
const falling = [
  { left: "26%", depth: "near", cycleDelay: 2 },
  { left: "61%", depth: "far", cycleDelay: 13 },
  { left: "84%", depth: "mid", cycleDelay: 24 },
];

const FloatingParticles = () => (
  <div className="login-particles" aria-hidden="true">
    {ambient.map((p, i) => (
      <span
        key={`a-${i}`}
        className="login-particle login-particle--ambient"
        style={{
          left: p.left,
          top: p.top,
          width: p.size,
          height: p.size,
          animationDuration: `${p.dur}s`,
          animationDelay: `${p.delay}s`,
        }}
      />
    ))}
    {active.map((p, i) => (
      <span
        key={`v-${i}`}
        className="login-particle login-particle--active"
        style={{
          left: p.left,
          top: p.top,
          width: p.size,
          height: p.size,
          animationDuration: `${p.dur}s`,
          animationDelay: `${p.delay}s`,
        }}
      />
    ))}
    {falling.map((p, i) => (
      <span
        key={`f-${i}`}
        className={`login-particle login-particle--fall login-particle--fall-${p.depth}`}
        style={{
          left: p.left,
          animationDelay: `${p.cycleDelay}s`,
        }}
      />
    ))}
  </div>
);

export default FloatingParticles;
